export function getClassNames(...classes: (string | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}
